import { useHistory } from '@ztechapps/common.hook'
import React from 'react'
import { routesDef } from '../../config/routes'
import { useUser } from '../../hooks/useUser'
import { ShowIf } from '@ztechapps/webui.util'

export const SeeYourOrderButton = ({ _id }) => {
  const history = useHistory()
  const { loggedIn } = useUser()

  return (
    <ShowIf condition={loggedIn}>
      <button
        type="button"
        className="mt-5 mb-5 btn btn-lg btn-primary"
        onClick={(e) => {
          e.preventDefault()
          history.push(routesDef.AccountOrderItem.altPath({ _id }))
        }}
      >
        See your order...
      </button>
    </ShowIf>
  )
}
